import { CoreIcon } from '../core-icon';
import coinCircleFillSVG from '../../assets/icons/coin-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const CoinCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={coinCircleFillSVG} {...props} />;
};
